import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/contactus.scss";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const initialFormData = {
  fullName: "",
  email: "",
  message: "",
};

function Contact() {
  const [formData, setFormData] = useState(initialFormData);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (!showSuccess) return undefined;

    const timeoutId = window.setTimeout(() => setShowSuccess(false), 5000);
    return () => window.clearTimeout(timeoutId);
  }, [showSuccess]);

  const handleInputChange = ({ target: { name, value } }) => {
    setFormData((currentFormData) => ({
      ...currentFormData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData(initialFormData);
    setShowSuccess(true);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="contact" id="MainContent">
      <div className="contact__container">
        <h1>Contact Us</h1>

        <div className="contact__details">
          <p>
            <strong>Email:</strong>{" "}
            <Link onClick={toTop} to="mailto:zone@camartzuno.store">
              zone@camartzuno.store
            </Link>
          </p>
          <p>
            <strong>Exchange Policy:</strong> Exchange any unworn, unwashed or
            defective merchandise by first contacting{" "}
            <Link onClick={toTop} to="mailto:zone@camartzuno.store">
              zone@camartzuno.store
            </Link>
          </p>
          <p>
            <strong>Shipping/Delivery:</strong> Please see our{" "}
            <Link to="/shipping" onClick={scrollToTop}>
              shipping policy here.
            </Link>
          </p>
          <p>
            <Link to="/faqs" onClick={scrollToTop}>
              View more frequently asked questions here.
            </Link>
          </p>
        </div>

        <form className="contact__form" onSubmit={handleSubmit}>
          <label className="contact__field">
            <span className="contact__label">Full Name</span>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="Full Name"
              autoComplete="name"
              required
            />
          </label>

          <label className="contact__field">
            <span className="contact__label">Email</span>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email"
              autoComplete="email"
              required
            />
          </label>

          <label className="contact__field contact__message-field">
            <span className="contact__label">Message</span>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              placeholder="Message"
              required
            />
          </label>

          <button type="submit" className="contact__submit">
            Send
          </button>

          {showSuccess && (
            <p className="contact__success" role="status">
              Thank you! We&apos;ll be in touch soon.
            </p>
          )}

        </form>
      </div>
    </main>
  );
}

export default Contact;
